import { render } from "./App.vue?vue&type=template&id=7343069a"
const script = {}

import "./App.vue?vue&type=style&index=0&id=7343069a&lang=css"
script.render = render

export default script